export default {
  'intl-locale': 'de-DE',
  system: {
    loading: 'Laden...',
    error: {
      title: 'Systemfehler',
      message:
        'Leider ist ein Systemfehler aufgetreten. Versuchen Sie es erneut.'
    }
  },
  filter: {
    select: 'auswählen',
    'btn-submit-text': 'Filter',
    'btn-clear-text': 'Reinigen',
    'nav-between-groups': 'Filtergruppe {{group}}/{{totalGroup}}',
    'complement-or': 'Filter - Komplementär (OR)',
    'refine-and': 'Filter - Verfeinern (AND)',
    loading: 'Filter laden...',
    filters: 'Filter'
  },
  'filter-composition': {
    'label-field': 'Filterzusammensetzung'
  },
  filteractions: {
    'select-label': 'Filter Actions',
    'initial-selection': 'Erstmaliges Zurücksetzen des Filters'
  },
  pagination: {
    pages: 'Seiten',
    'go-to-page': 'Gehe zur Seite'
  },
  'data-table': {
    selection: 'Auswahl',
    actions: 'Aktionen',
    'no-records-found': 'Keine Datensätze gefunden',
    'select-all': 'Wählen Sie alle',
    'navigate-between-table-columns': 'Navigieren Sie zwischen Tabellenspalten',
    previous: 'Vorherige',
    next: 'Nächste'
  },
  multifree: {
    item: 'Element',
    items: 'Elemente',
    add: 'hinzufügen',
    remove: 'entfernen',
    clear: 'löschen'
  },
  uniselection: {
    clear: 'löschen',
    'show-options': 'Optionen anzeigen',
    'hide-options': 'Optionen ausblenden'
  },
  multiselection: {
    clear: 'löschen',
    'show-options': 'Optionen anzeigen',
    'hide-options': 'Optionen ausblenden',
    selection: 'Auswahl',
    selections: 'Auswahlen',
    'option-selected': 'Option ausgewählt',
    'options-selected': 'Optionen ausgewählt',
    selections_one: '{{count}} auswahl',
    selections_multiple: '{{count}} auswahlmöglichkeiten'
  },
  datepicker: {
    select: 'auswählen'
  },
  'navigation-slider': {
    previous: 'Gehe zum vorherigen',
    next: 'Gehen Sie zum nächsten',
    beginning: 'Gehen Sie zum Anfang',
    last: 'Gehen Sie zum letzten',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen'
  },
  task: {
    model: 'Aufgabenmodell',
    sid: 'Aufgaben SID',
    'assigned-requester': 'Zugewiesener Anforderer',
    'assigned-executor': 'Zugeordneter Vollstrecker',
    'scheduled-submission': 'Geplante Abgabe um',
    'scheduled-start': 'Geplanter Beginn um',
    priority: {
      low: 'niedrige',
      normal: 'normale',
      high: 'hohe',
      urgent: 'dringende'
    },
    action: {
      approve: 'Genehmigen',
      cancel: 'Stornieren',
      copy: 'Kopieren',
      deliver: 'Liefern',
      lock: 'Sperren',
      'mark-as-failed': 'Als fehlgeschlagen markieren',
      pause: 'Pausieren',
      reject: 'Abweisen',
      restart: 'Neu starten',
      resume: 'Wieder aufnehmen',
      return: 'Zurückkehren',
      start: 'Starten',
      take: 'Nehmen',
      unlock: 'Entsperren',
      view: 'Ansehen',
      execute: 'Ausführen'
    }
  },
  'loading-page': {
    heading: 'Die Seite wird geladen',
    complement: 'Das kann ein Paar Minuten dauern.\nBitte warten.'
  },
  'transfer-order-card': {
    shipper: 'Lieferant',
    receiver: 'Empfänger',
    'delivery-order': 'Lieferauftrag',
    'receipt-order': 'Quittungsauftrag',
    'order-table-header': 'Befehl | Beschreibung | Menge | Maßeinheit',
    view: 'Sehen'
  },
  'route-section': {
    'sid-label': 'Route SID',
    estimated: 'Geschätzte Zeit und Geschätzte Entfernung'
  },
  'transport-card': {
    route: 'Route',
    checkpoints: 'Wegpunkte'
  },
  'checkpoint-section': {
    status: {
      todo: 'Besuchen',
      doing: 'Gestartet',
      done: 'Fertig'
    },
    'map-button': 'Karte',
    view: 'Sicht',
    'transfer-order': 'Überweisungsaufträge'
  },
  'priority-tag': {
    low: 'niedrig',
    normal: 'normal',
    high: 'hoch',
    urgent: 'dringend'
  },
  'training-card': {
    duration: 'Dauer',
    seconds: 'sekunden',
    minutes: 'minutes',
    'play-video': 'video spielen'
  },
  '503-error': {
    title: 'Wir sind vorübergehend nicht erreichbar',
    'description-1': 'Unsere Dienste sind derzeit nicht verfügbar.',
    'description-2':
      'Bitte gehen Sie zur Startseite oder versuchen Sie es gleich noch einmal.',
    'try-again': 'Versuchen Sie es erneut',
    'alt-img': 'Fehler 503'
  },
  saf: {
    legend: 'Legende',
    in: 'Eingänge',
    out: 'Ausgänge',
    'initial-stock': 'Erstinventur',
    'final-stock': 'Endgültige Lagerung',
    totals: 'Summen'
  },
  'text-fading': {
    'read-more': 'Mehr lesen',
    'read-less': 'Weniger lesen'
  },
  accordion: {
    'summary-item': 'Zusammenfassungselement',
    'toggle-accordion': 'Akkordeon umschalten'
  },
  'contact-object-card': {
    'phone-number': 'Telefonnummer'
  }
}
